export default __webpack_public_path__ + "static/media/hamburger.0eca8c17.svg";